// extracted by mini-css-extract-plugin
export default {"shimmerLoaderWrapper":"ShimmerLoader_shimmerLoaderWrapper__InYIP"};